








































import {
  genPostReq
} from "@/services/checklist.service";


import { EventBus } from '@/event-bus.js';

export default {
  data() {
    return {
      initLoaded: false,
      snackbar: false,
      snackbar_text: "",
      list: [],
      headers: [
          {
            text: 'Komponente', 
            value: 'name',
          },
          { text: 'Aufgabe', value: 'task_name' },
            { text: 'Prüfergebnisse', value: 'task_name' },
      ],
    };
  },
  components: {

  },

  mounted() {
    this.$store.state.headerTitle = "Doppelte IDs - Prüfergebnisse"
    this.$store.state.cl_uid = this.$route.params.uid;
    EventBus.$on('show_toast', this.show_snackbar);




    genPostReq('checklist', 'check-id-options', { "cl_uid" :  this.$store.state.cl_uid })
    .then(resp => {

        this.initLoaded = true
        if (resp.status == "success") {
            this.list = resp.data

            console.log(this.list)
        }
    })
    .catch(e => {
        this.$store.dispatch("api_error", e);
    }); 


  },
  computed: {


  },
  methods: {
    itemClicked: function () {
      console.log("oh ja")
    },
    rowClick: function (item) {

        let str = item.item.cl_uid+"/"; 

        for (var i=0 ; i<6 ; i++) {
            if (item.item.comp_path[i]) {

                str += item.item.comp_path[i].uid+"/"
                console.log("gefunden")
            } else {
                str += "c"+(i+1)+"/";
            }
        }

        str += item.item.task_uid+"/"+item.item.question_uid
     

        let route = this.$router.resolve({path: '/checklist/'+str});
        window.open(route.href, '_blank');
    }
    
  }
};
